import { useCallback } from "react";
import { useSafePostHog } from "@hooks/use_posthog.ts";

export function useTrackBannerDismissed(banner: string, properties?: Record<string, unknown>) {
  const posthog = useSafePostHog();

  const serializedProperties = JSON.stringify(properties ?? {});

  return useCallback(() => {
    posthog?.capture("banner_dismissed", {
      banner,
      ...(JSON.parse(serializedProperties) as Record<string, unknown>),
    });
  }, [posthog, banner, serializedProperties]);
}
